import React from "react";

/* What a TabPanel reads from its Tabs: the selected value, the id base both
   halves derive their ids from, and the panel registry that decides whether a
   tab may point at its panel with aria-controls. */
export interface TabsContextValue {
  value: string;
  baseId: string;
  registerPanel: (value: string) => () => void;
}

export const TabsContext = React.createContext<TabsContextValue | null>(null);

const safe = (v: string) => v.replace(/[^\w-]/g, "_");
export const tabId = (base: string, value: string) =>
  `${base}-tab-${safe(value)}`;
export const panelId = (base: string, value: string) =>
  `${base}-panel-${safe(value)}`;
